
import { CMSService } from "./CMSService";



export const useCMSSingelton= new CMSService();
